import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const fieldBox = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s4,
  },
]);

export const selectFormInfoTitle = style([
  {
    marginBottom: space.s20,
  },
]);

export const checkbox = style([
  typography.bodyMd,
  {
    display: 'flex',
    gap: space.s8,
    color: themeVars.container.foreground.secondary,
  },
]);

export const modalList = style([
  typography.bodyMd,
  {
    color: themeVars.container.foreground.secondary,
    paddingLeft: space.s20,
    margin: `0 0 ${space.s28}px 0`,
  },
]);

export const cancelSubscriptionForm = style([
  {
    gap: space.s20,
  },
]);
